<template>
  <svg
    class="icon icon-php"
    xmlns="http://www.w3.org/2000/svg"
    baseProfile="tiny"
    version="1.2"
    viewBox="0 0 32 32"
    :width="width"
    :height="width"
  >
    <title>php</title>
    <path d="M9.347 13.609h-1.259l-0.687 3.531h1.117c0.741 0 1.293-0.14 1.656-0.419 0.363-0.28 0.607-0.745 0.733-1.399 0.123-0.627 0.067-1.069-0.165-1.327-0.233-0.257-0.697-0.387-1.396-0.387z"></path>
    <path d="M16 7.584c-8.836 0-16 3.768-16 8.416s7.164 8.417 16 8.417 16-3.769 16-8.417c0-4.648-7.164-8.416-16-8.416zM11.653 17.519c-0.348 0.333-0.767 0.584-1.223 0.735-0.448 0.144-1.020 0.219-1.713 0.219h-1.575l-0.436 2.241h-1.837l1.64-8.435h3.533c1.063 0 1.837 0.279 2.325 0.837 0.488 0.557 0.635 1.336 0.44 2.336-0.082 0.425-0.223 0.803-0.416 1.148l0.010-0.019c-0.191 0.34-0.44 0.653-0.748 0.937zM17.019 18.472l0.724-3.732c0.084-0.424 0.052-0.715-0.091-0.868-0.143-0.155-0.448-0.232-0.916-0.232h-1.456l-0.939 4.833h-1.824l1.64-8.436h1.823l-0.436 2.243h1.624c1.023 0 1.727 0.179 2.115 0.535s0.504 0.933 0.351 1.732l-0.763 3.925h-1.852zM27.148 15.452c-0.080 0.425-0.221 0.803-0.416 1.148l0.010-0.018c-0.191 0.34-0.44 0.653-0.748 0.937-0.338 0.323-0.746 0.574-1.2 0.728l-0.023 0.007c-0.448 0.144-1.020 0.219-1.715 0.219h-1.573l-0.436 2.243h-1.837l1.64-8.435h3.532c1.063 0 1.837 0.279 2.325 0.837 0.488 0.556 0.636 1.335 0.441 2.335z"></path>
    <path d="M23.688 13.609h-1.257l-0.688 3.531h1.117c0.743 0 1.295-0.14 1.656-0.419 0.363-0.28 0.607-0.745 0.735-1.399 0.123-0.627 0.065-1.069-0.167-1.327s-0.699-0.387-1.396-0.387z"></path>
  </svg>
</template>

<script>
export default {
  name: 'php',
  props: {
    width: {
      type: Number,
      default: 50,
      required: false
    }
  }
}
</script>
